import {FC, ReactNode, memo, useCallback, useEffect, useMemo, useState} from 'react'
import {ContactGroupMap, GetContactParams, Tag} from '../../../../../services/cellcast.v2.types'
import moment from 'moment'
import {OverlayTrigger, Spinner, Tooltip} from 'react-bootstrap'
import {AuthenticateUser} from '../../../../Utils/_helpers/RoleAndPermission'
import ContactListFilter from '../../../../Components/ContactListFilter'
import ContactListActions from './ContactListActions'
import PrevNexPaginate from '../../../../Components/PrevNextPaginate'
import {uniq} from 'lodash'
import {MenuComponent} from '../../../../../_metronic/assets/ts/components'
import {toast} from 'react-toastify'
import {useDispatch, useSelector} from 'react-redux'
import {getIsDefaultRegion} from '../../accounts/Overview/OverviewSlice/UserDetailsSlice'
import {getUserData} from '../../../../modules/auth/components/Frontend_Auth_Components/UserLoginRedux/UserLoginSlice'
import Filter from './Filter'
import SettingFields from './Modal/SettingFields'
import DeleteConfirmationPopup from '../../../../Components/DeleteConfirmationPopup'
import {DeleteData} from '../Tags/TagSlice/TagsSlices'
import {DeleteContactFromList} from '../../../AdminPages/Templates/Tags/TagSlice/TagsSlices'
import {GetAllTeamList} from '../../accounts/Overview/OverviewSlice/TeamListSlice'
import {PortalNotifiationBySuperAdmin} from '../../../../Redux/AdminPanel/CommentSlice'
import {fetchAsyncUserDetails} from '../../accounts/Overview/OverviewSlice/UserDetailsSlice'
import {ContactMobileCard} from './ContactMobileCard'
import './ContactListPanel.scss'
import { formatDateOrDash } from '../../../../Utils/_helpers/birthday'
import { isNumber } from '../../../../Utils/_helpers/number'
import {useResponsive} from '../../../../hooks/useResponsive'

type ContactListPanelProps = {
  groupId: string
  contacts: ContactGroupMap[]
  tags?: Tag[]
  tagID?: string

  next: number | null
  prev: number | null
  loadedData: number
  totalData: number
  handleChangePage: (page: number | null, next: boolean) => void

  groupField: string[]

  isLoading: boolean
  isFetchLoading: boolean
  isCountLoading: boolean
  isFetchCountLoading: boolean
  isLoadingExport: boolean
  isDeleteLoading?: boolean

  selectedContactGroupIDs: string[]
  setSelectedContactGroupIDs: (contacts: string[]) => void
  selectedContactIDs: string[]
  setSelectedContactIDs: (contacts: string[]) => void
  isLoadingSubAndUnSub: boolean

  params: GetContactParams
  setParams: (params: GetContactParams) => void

  showFilterStatus?: boolean
  showFilterTag?: boolean
  showSendMessageAction?: boolean
  showSubscribeStatus?: boolean
  showExport?: boolean
  showTag?: boolean
  showAddTag?: boolean
  showFilterField?: boolean
  showDeleteContactList?: boolean

  doFetchData: (fetchGroup: boolean) => void

  handleChangSizeData: (size: number) => void
  handleShowDetailContact?: (number: string, contactId: string) => void
  handleShowAddSingleContact?: (isShow: boolean) => void
  handleShowEditContact?: (params: ContactGroupMap) => void
  handleExport: () => void
  handleShowQmDrawer: (isShow: boolean) => void
  handleShowBm: () => void
  handleShowAddContactModal: (isShow: boolean) => void
  handleShowReSubscribeContactModal: (isShow: boolean) => void
  handleShowAttachTagModal: (isShow: boolean) => void
  handleSubscribe: (contactIDs: string[]) => void
  handleUnsubscribe: (contactIDs: string[]) => void
  handleDelete: () => void
  handleSetSort?: (key: string, value: string) => void

  Header?: ReactNode
}

const ContactListPanel: FC<ContactListPanelProps> = (props) => {
  const {
    groupId,
    contacts,
    doFetchData,
    groupField,
    params,
    setParams,
    isLoading,
    isFetchLoading,
    isCountLoading,
    isFetchCountLoading,
    isLoadingExport,
    isDeleteLoading,
    next,
    prev,
    loadedData,
    totalData,
    handleChangSizeData,
    handleShowEditContact,
    handleShowAddSingleContact,
    tags,
    tagID,
    selectedContactGroupIDs,
    setSelectedContactGroupIDs,
    selectedContactIDs,
    setSelectedContactIDs,
    isLoadingSubAndUnSub,
    showFilterStatus,
    showFilterTag,
    showSendMessageAction,
    showSubscribeStatus,
    showTag,
    showExport,
    showAddTag,
    showFilterField,
    showDeleteContactList,

    handleExport,
    handleShowQmDrawer,
    handleShowBm,
    handleShowAddContactModal,
    handleShowReSubscribeContactModal,
    handleShowAttachTagModal,
    handleSubscribe,
    handleUnsubscribe,
    handleDelete,
    handleChangePage,
    handleSetSort,
    Header,
  } = props
  const dispatch = useDispatch()

  const isDefaultRegion = useSelector(getIsDefaultRegion)
  const userData = useSelector(getUserData)?.user
  const OwnerId = userData?._id

  // Fetch team list for assignment
  const Teamlist = useSelector((state: any) => {
    const teamData = state?.teamlist?.TeamList?.items || []
    const user = state.userDetails.userDetails?.data?.user
    return [user, ...teamData]
  })

  // state
  const [isShowSettingField, setIsShowSettingFields] = useState(false)
  const [filteredGroupFields, setFilteredGroupFields] = useState<string[]>([])
  const {isMobile} = useResponsive()

  const [open, setOpen] = useState(false)

  // actions
  const handleCheckAll = () => {
    if (selectedContactGroupIDs?.length === contacts.length) {
      setSelectedContactGroupIDs([])
    } else {
      let list = contacts.map((key) => key._id)
      setSelectedContactGroupIDs([...list])
    }

    if (selectedContactIDs?.length === contacts.length) {
      setSelectedContactIDs([])
    } else {
      let list = contacts.map((key) => key.contact?._id)
      setSelectedContactIDs([...list])
    }
  }

  const handleCheck = (e: ContactGroupMap) => {
    if (selectedContactGroupIDs.includes(e._id)) {
      // update selected contact group ids
      selectedContactGroupIDs.splice(selectedContactGroupIDs.indexOf(e._id), 1)
      setSelectedContactGroupIDs([...selectedContactGroupIDs])

      // update selected contact id
      selectedContactIDs.splice(selectedContactIDs.indexOf(e?.contact?._id ?? e?._id), 1)
      setSelectedContactIDs([...selectedContactIDs])
    } else {
      setSelectedContactGroupIDs([...selectedContactGroupIDs, e._id])
      setSelectedContactIDs([...selectedContactIDs, e?.contact?._id ?? e?._id])
    }
  }
  const isShowSubscribeButton = () => {
    const foundContacts = contacts.filter(
      (el) =>
        (el.isBlocked || el.isBlockedByUser || el.is_blocked) &&
        selectedContactGroupIDs.includes(el._id)
    )

    return foundContacts.length > 0
  }

  const isShowUnsubscribeButton = () => {
    const foundContacts = contacts.filter(
      (el) =>
        !el.isBlocked &&
        !el.isBlockedByUser &&
        !el.is_blocked &&
        selectedContactGroupIDs.includes(el._id)
    )

    return foundContacts.length > 0
  }

  const handleUnsubscribeSelected = useCallback(() => {
    handleUnsubscribe(selectedContactIDs)
  }, [handleUnsubscribe, selectedContactIDs])

  const handleSubscribeSelected = useCallback(() => {
    handleSubscribe(selectedContactIDs)
  }, [handleSubscribe, selectedContactIDs])

  const handleDeleteSelected = useCallback(
    (contactGroupId: string) => {
      setSelectedContactGroupIDs([contactGroupId])
      handleDelete()
    },
    [handleDelete, setSelectedContactGroupIDs]
  )

  const handleQmSelected = useCallback(
    (contactGroupId: string) => {
      setSelectedContactGroupIDs([contactGroupId])
      handleShowQmDrawer(true)
    },
    [handleShowQmDrawer, setSelectedContactGroupIDs]
  )

  // Fetch team list on component mount
  useEffect(() => {
    if (OwnerId && AuthenticateUser('list-sub-accounts')) {
      dispatch(GetAllTeamList({ownerId: OwnerId}))
      dispatch(fetchAsyncUserDetails())
    }
  }, [OwnerId, dispatch])

  const handleAssignTo = useCallback(
    (staffMember: any) => {
      if (selectedContactGroupIDs.length === 0) {
        toast.error('Please select at least one contact')
        return
      }

      const contactNumbers = selectedContactGroupIDs
        .map((contactId) => contacts.find((c) => c._id === contactId)?.number)
        .filter(Boolean)
        .join(', ')

      dispatch(
        PortalNotifiationBySuperAdmin({
          userTo: [staffMember?._id],
          message: `New contacts are assigned to you. check these ${contactNumbers} in your inbox chat`,
          type: 'inbox',
          action: 'assign-contact',
          contactId: selectedContactGroupIDs,
        })
      ).then(() => {
        dispatch(GetAllTeamList({ownerId: OwnerId})).then(() => {
          dispatch(fetchAsyncUserDetails())

          doFetchData(false)

          toast.success(
            `${selectedContactGroupIDs.length} contact${
              selectedContactGroupIDs.length > 1 ? 's' : ''
            } assigned to ${staffMember?.name}`
          )
          setSelectedContactGroupIDs([])
          setSelectedContactIDs([])
        })
      })
    },
    [
      selectedContactGroupIDs,
      selectedContactIDs,
      OwnerId,
      dispatch,
      setSelectedContactGroupIDs,
      setSelectedContactIDs,
      doFetchData,
    ]
  )

  const getAssignedPerson = useCallback(
    (contactId: string) => {
      const isAssignedToCurrentUser = userData?.assignedContacts?.includes(contactId)
      if (isAssignedToCurrentUser) {
        return userData
      }

      const assignedTeamMember = Teamlist?.find((teamMember: any) =>
        teamMember?.assignedContacts?.includes(contactId)
      )
      return assignedTeamMember || null
    },
    [userData, Teamlist]
  )

  useEffect(() => {
    setFilteredGroupFields(uniq(groupField))
  }, [groupField])

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [props])

  const SettingFieldsModal = useMemo(
    () => (
      <SettingFields
        id={groupId}
        show={isShowSettingField}
        handleClose={() => {
          setIsShowSettingFields(false)
        }}
        callbackFn={() => {
          doFetchData(true)
          setIsShowSettingFields(false)
        }}
        fields={groupField}
      />
    ),
    [groupField, isShowSettingField]
  )

  const handleDeleteContactList = useCallback(() => {
    if (tagID) {
      const selectedContact = selectedContactGroupIDs.length
        ? selectedContactGroupIDs
        : contacts.map((key) => key._id)
      dispatch(DeleteContactFromList({contactIDs: selectedContact, listID: tagID}))
      setOpen(false)
      doFetchData(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedContactGroupIDs, contacts, groupId])

  const ModalConfirmationDelete = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={open}
        handleClose={() => setOpen(false)}
        checklist={() => {}}
        Message={'Are you sure, you want to delete contact from list?'}
        confirm={() => handleDeleteContactList()}
      />
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [open]
  )

  return (
    <div className='card mb-0'>
      {SettingFieldsModal}
      {ModalConfirmationDelete}
      <div className={`card-header align-items-center border-bottom-0 ${isMobile ? 'contact-list-header-mobile' : ''}`}>
        {Header !== undefined && (
          <div className={isMobile ? 'mb-3' : ''}>{Header}</div>
        )}
        <div className={isMobile ? 'd-flex flex-column gap-3' : 'w-100 d-flex justify-content-between align-items-center'}>
          <ContactListFilter
            params={params}
            setParams={setParams}
            doFetchData={() => doFetchData(false)}
            tags={tags || []}
            showFilterStatus={showFilterStatus}
            showFilterTag={showFilterTag}
            groupField={groupField}
          />
          <ContactListActions
            handleShowBm={handleShowBm}
            params={params}
            contacts={contacts}
            selectedContactGroupIDs={selectedContactGroupIDs}
            showActionOptions={showSendMessageAction}
            handleDelete={handleDelete}
            showModalConfirmationDeleteList={() => setOpen(true)}
            handleExport={handleExport}
            isLoadingExport={isLoadingExport}
            handleShowAddContactModal={handleShowAddContactModal}
            handleShowAddSingleContact={handleShowAddSingleContact}
            handleShowReSubscribeContactModal={handleShowReSubscribeContactModal}
            handleShowAttachTagModal={handleShowAttachTagModal}
            handleShowQmDrawer={handleShowQmDrawer}
            handleSubscribe={handleSubscribeSelected}
            handleUnsubscribe={handleUnsubscribeSelected}
            showSubscribeButton={isShowSubscribeButton()}
            showUnsubscribeButton={isShowUnsubscribeButton()}
            showExportContactButton={showExport}
            showAddTagButton={showAddTag}
            showDeleteContactList={showDeleteContactList}
            teamMembers={Teamlist}
            handleAssignTo={handleAssignTo}
          />
        </div>
      </div>
      {isLoading ? (
        <div className='row flex-center h-200 mb-10 mt-10'>
          <Spinner />
        </div>
      ) : (
        <div className='card-body pt-2'>
          <div className='tab-content'>
            <Filter
              filterFieldEnable={showFilterField === undefined ? true : showFilterField}
              tags={tags || []}
              params={params}
              setParams={setParams}
              doFetchData={() => doFetchData(false)}
              groupField={groupField}
            />
            {/* Mobile view: Card layout */}
            {isMobile ? (
              <div className='mobile-contacts-list'>
                {isFetchLoading ? (
                  <div className='text-center py-5'>
                    <Spinner />
                  </div>
                ) : contacts.length === 0 ? (
                  <div className='text-center py-5 text-muted'>No contacts found</div>
                ) : (
                  contacts?.map((contact) => (
                    <ContactMobileCard
                      key={contact._id}
                      contact={contact}
                      isSelected={selectedContactGroupIDs.includes(contact._id)}
                      onSelect={(id) => {
                        if (selectedContactGroupIDs.includes(id)) {
                          setSelectedContactGroupIDs(
                            selectedContactGroupIDs.filter((cId) => cId !== id)
                          )
                        } else {
                          setSelectedContactGroupIDs([...selectedContactGroupIDs, id])
                        }
                      }}
                      onDelete={() => {
                        setSelectedContactGroupIDs([contact._id])
                        handleDelete()
                      }}
                      onSubscribe={() => handleSubscribe([contact.contact?._id ?? contact._id])}
                      onUnsubscribe={() => handleUnsubscribe([contact.contact?._id ?? contact._id])}
                      showTag={showTag}
                      showSubscribeStatus={showSubscribeStatus}
                      groupFields={filteredGroupFields}
                      actions={[
                        {
                          key: 'edit',
                          label: 'Edit Contact',
                          icon: 'bi bi-pencil',
                          onClick: () => handleShowEditContact?.(contact),
                        },
                        {
                          key: 'message',
                          label: 'Send Message',
                          icon: 'bi bi-send',
                          onClick: () => handleShowQmDrawer(true),
                        },
                      ]}
                    />
                  ))
                )}
              </div>
            ) : (
              /* Desktop view: Table layout */
              <div className='table-responsive  max-h-750'>
                <table className='table table-bordered sticky-header table-last-column table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                  <thead>
                    <tr className='fw-bold text-muted text-uppercase'>
                      <th className='w-25px'>
                        <div className='ms-5 form-check form-check-sm form-check-custom form-check-solid'>
                          <input
                            className='form-check-input form-check-input-custom'
                            type='checkbox'
                            value='ALL'
                            data-kt-check='true'
                            data-kt-check-target='.widget-9-check'
                            checked={
                              selectedContactGroupIDs?.length >= contacts.length &&
                              contacts.length > 0
                            }
                            onChange={handleCheckAll}
                          />
                        </div>
                      </th>
                      <th>Mobile</th>
                      {showTag && <th>Tags</th>}
                      {showTag && <th>List</th>}
                      {filteredGroupFields.map((val, i) => {
                        return (
                          <th
                            key={i}
                            onClick={() =>
                              isDefaultRegion &&
                              handleSetSort &&
                              handleSetSort(
                                `fields.${val}`,
                                params.sortKey === `fields.${val}`
                                  ? params.sortValue === 'desc'
                                    ? 'asc'
                                    : 'desc'
                                  : 'asc'
                              )
                            }
                          >
                            {isDefaultRegion && (
                              <>
                                {params.sortKey === `fields.${val}` ? (
                                  params.sortValue && params.sortValue === 'desc' ? (
                                    <i className='bi bi-arrow-up-short me-2'></i>
                                  ) : (
                                    <i className='bi bi-arrow-down-short me-2'></i>
                                  )
                                ) : (
                                  <i className='bi bi-arrow-down-up me-2'></i>
                                )}
                              </>
                            )}

                            {val}
                          </th>
                        )
                      })}

                      <th style={{width: 130}}>Unsubscribe At</th>

                      <th
                        style={{width: 130}}
                        onClick={() =>
                          isDefaultRegion &&
                          handleSetSort &&
                          handleSetSort(
                            'updatedAt',
                            params.sortKey === 'updatedAt'
                              ? params.sortValue === 'desc'
                                ? 'asc'
                                : 'desc'
                              : 'desc'
                          )
                        }
                      >
                        {isDefaultRegion && (
                          <>
                            {params.sortKey === 'updatedAt' ? (
                              params.sortValue && params.sortValue === 'desc' ? (
                                <i className='bi bi-arrow-up-short me-2'></i>
                              ) : (
                                <i className='bi bi-arrow-down-short me-2'></i>
                              )
                            ) : (
                              <i className='bi bi-arrow-down-up me-2'></i>
                            )}
                          </>
                        )}
                        Contact Updated
                      </th>
                      <th
                        style={{width: 130}}
                        onClick={() =>
                          isDefaultRegion &&
                          handleSetSort &&
                          handleSetSort(
                            'createdAt',
                            params.sortKey === 'createdAt'
                              ? params.sortValue === 'desc'
                                ? 'asc'
                                : 'desc'
                              : 'desc'
                          )
                        }
                      >
                        {isDefaultRegion && (
                          <>
                            {params.sortKey === 'createdAt' ? (
                              params.sortValue && params.sortValue === 'desc' ? (
                                <i className='bi bi-arrow-up-short me-2'></i>
                              ) : (
                                <i className='bi bi-arrow-down-short me-2'></i>
                              )
                            ) : (
                              <i className='bi bi-arrow-down-up me-2'></i>
                            )}
                          </>
                        )}
                        Contact Added
                      </th>
                      <th>Creator</th>
                      <th>Create From</th>
                      {AuthenticateUser('list-sub-accounts') && <th>Assigned To</th>}
                      {showSubscribeStatus && <th>Status</th>}
                      {showSubscribeStatus && <th>Last Message</th>}

                      <th style={{minWidth: 150}}>
                        Action
                        <span onClick={() => setIsShowSettingFields(true)}>
                          <i className='bi bi-pencil-fill ms-3'></i>
                        </span>
                      </th>
                    </tr>
                  </thead>
                  <tbody className='text-gray-600'>
                    {isFetchLoading ? (
                      <tr>
                        <td
                          colSpan={
                            7 +
                            groupField.length +
                            (groupField.length > 3 ? groupField.length - 3 : 0) +
                            (showSubscribeStatus ? 1 : 0)
                          }
                          className='text-center'
                        >
                          <Spinner />
                        </td>
                      </tr>
                    ) : (
                      <>
                        {contacts.length > 0 ? (
                          contacts.map((val, i) => (
                            <tr key={i}>
                              <td>
                                <div className='ms-5 form-check form-check-sm form-check-custom form-check-solid'>
                                  <input
                                    className='form-check-input widget-9-check'
                                    type='checkbox'
                                    value={val?._id}
                                    checked={selectedContactGroupIDs.includes(val?._id)}
                                    onChange={() => handleCheck(val)}
                                  />
                                </div>
                              </td>
                              <td
                                className='cursor-pointer'
                                onClick={() => {
                                  if (props.handleShowDetailContact) {
                                    props.handleShowDetailContact(
                                      val.number,
                                      val.contact?._id ?? val?._id
                                    )
                                  }
                                }}
                              >
                                <b>{val?.full_number ?? val?.number}</b>
                              </td>
                              {showTag && (
                                <td
                                  data-bs-toggle='tooltip'
                                  data-bs-placement='top'
                                  title={val?.tags
                                    ?.filter((data: any) => {
                                      if (data?.type) {
                                        return data?.isHidden !== false && data?.type !== 'list'
                                      }
                                      return data?.isHidden !== false
                                    })
                                    ?.map((data: any) => data?.name)
                                    .join()}
                                >
                                  <div className='d-flex gap-2 align-items-center flex-wrap '>
                                    {val?.tags
                                      ?.filter((data: any) => {
                                        if (data?.type) {
                                          return data?.isHidden !== false && data?.type !== 'list'
                                        }
                                        return data?.isHidden !== false
                                      })
                                      ?.map(
                                        (
                                          data: {_id: string; name: string; color: string},
                                          i: number
                                        ) => (
                                          <div
                                            key={i}
                                            className='inbox-tags'
                                            style={{
                                              color: data?.color ? 'white' : 'black',
                                              backgroundColor: data?.color ? data?.color : '',
                                            }}
                                          >
                                            {data?.name}
                                          </div>
                                        )
                                      )}
                                  </div>
                                </td>
                              )}

                              {showTag && (
                                <td
                                  data-bs-toggle='tooltip'
                                  data-bs-placement='top'
                                  title={val?.tags
                                    ?.filter((data: any) => {
                                      if (data?.type) {
                                        return data?.isHidden !== false && data?.type === 'list'
                                      }
                                      return data?.isHidden !== false
                                    })
                                    ?.map((data: any) => data?.name)
                                    .join()}
                                >
                                  <div className='d-flex gap-2 align-items-center flex-wrap '>
                                    {val?.tags
                                      ?.filter((data: any) => {
                                        if (data?.type) {
                                          return data?.isHidden !== false && data?.type === 'list'
                                        }
                                        return data?.isHidden !== false
                                      })
                                      ?.map(
                                        (
                                          data: {_id: string; name: string; color: string},
                                          i: number
                                        ) => (
                                          <div
                                            key={i}
                                            className='inbox-tags'
                                            style={{
                                              color: data?.color ? 'white' : 'black',
                                              backgroundColor: data?.color ? data?.color : '',
                                            }}
                                          >
                                            {data?.name}
                                          </div>
                                        )
                                      )}
                                  </div>
                                </td>
                              )}

                              {filteredGroupFields.map((Fields: any, i: number) => {
                                let check = val?.fields?.map((key: any) => key?.name)
                                if (check?.includes(Fields)) {
                                  if (['Birthday'].includes(Fields)) {
                                    return (
                                      <td key={i}>
                                        {formatDateOrDash(
                                          val?.fields.find((key: any) => key?.name == Fields)?.value,
                                          'DD/MM/YYYY'
                                        )}
                                      </td>
                                    )
                                  }
                                  return (
                                    <td key={i}>
                                      {val?.fields?.find((key: any) => key?.name == Fields)?.value}
                                    </td>
                                  )
                                } else {
                                  return <td key={i}>--</td>
                                }
                              })}

                              <td>
                                {val?.blockedByUserAt
                                  ? moment
                                      .tz(val?.blockedByUserAt, moment.tz.guess())
                                      .format('D MMMM YYYY. hh:mm a')
                                  : '-'}
                              </td>
                              <td>
                                {moment
                                  .tz(val?.updatedAt, moment.tz.guess())
                                  .format('D MMMM YYYY. hh:mm a')}
                              </td>
                              <td>
                                {moment
                                  .tz(val?.createdAt, moment.tz.guess())
                                  .format('D MMMM YYYY. hh:mm a')}
                              </td>
                              <td>{val.creatorName || val.creator_name || '--'}</td>
                              <td>{val.createdFrom || val.created_from || '--'}</td>
                              {AuthenticateUser('list-sub-accounts') && (
                                <td>
                                  {(() => {
                                    const assignedPerson = getAssignedPerson(val._id)
                                    return assignedPerson ? (
                                      <span className='fs-7 fw-bold text-gray-600'>
                                        {assignedPerson?.name}
                                      </span>
                                    ) : (
                                      <span className='fs-7 text-muted'>--</span>
                                    )
                                  })()}
                                </td>
                              )}
                              {showSubscribeStatus && (
                                <td>
                                  {val?.isBlockedByUser || val?.isBlocked || val?.is_blocked
                                    ? 'Unsubscribed'
                                    : 'Subscribed'}
                                </td>
                              )}

                              {showSubscribeStatus && <td> {val?.lastMessage || '-'}</td>}

                              <td>
                                <div className='row me-5'>
                                  {AuthenticateUser('edit-contact') &&
                                    (isLoadingSubAndUnSub &&
                                    selectedContactIDs.includes(val.contact?._id) ? (
                                      <span
                                        className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary'
                                        onClick={() =>
                                          handleSubscribe([val?.contact?._id ?? val?._id])
                                        }
                                      >
                                        <Spinner size='sm' />
                                      </span>
                                    ) : (
                                      <>
                                        {val?.isBlockedByUser ||
                                        val?.isBlocked ||
                                        val?.is_blocked ? (
                                          <OverlayTrigger
                                            placement='bottom'
                                            delay={{show: 250, hide: 400}}
                                            overlay={
                                              <Tooltip id='tooltip-bottom'>Subscribe</Tooltip>
                                            }
                                          >
                                            <span
                                              className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary'
                                              onClick={() =>
                                                handleSubscribe([val?.contact?._id ?? val?._id])
                                              }
                                            >
                                              <i className='bi bi-person-fill-add fs-5 text-success'></i>
                                            </span>
                                          </OverlayTrigger>
                                        ) : (
                                          <OverlayTrigger
                                            placement='bottom'
                                            delay={{show: 250, hide: 400}}
                                            overlay={
                                              <Tooltip id='tooltip-bottom'>Unsubscribe</Tooltip>
                                            }
                                          >
                                            <span
                                              className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary'
                                              onClick={() =>
                                                handleUnsubscribe([val?.contact?._id ?? val?._id])
                                              }
                                            >
                                              <i className='bi bi-person-fill-dash fs-5 text-danger'></i>
                                            </span>
                                          </OverlayTrigger>
                                        )}
                                      </>
                                    ))}

                                  {(AuthenticateUser('send-quick-sms') ||
                                    AuthenticateUser('send-quick-sms')) && (
                                    <span
                                      className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary ms-3'
                                      data-kt-menu-trigger='hover'
                                      data-kt-menu-placement='bottom-end'
                                      data-kt-menu-overflow='false'
                                    >
                                      {isDeleteLoading &&
                                      selectedContactIDs.includes(val.contact?._id) ? (
                                        <Spinner animation='grow' size='sm' />
                                      ) : (
                                        <i className='bi bi-three-dots fs-5'></i>
                                      )}
                                    </span>
                                  )}
                                  <div
                                    className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-state-bg-light-primary fw-bold fs-7 w-200px py-4'
                                    data-kt-menu={isDeleteLoading ? 'false' : 'true'}
                                  >
                                    {AuthenticateUser('send-quick-sms') && (
                                      <div className='menu-item px-3'>
                                        <span
                                          className='menu-link px-3'
                                          onClick={() => handleQmSelected(val._id)}
                                        >
                                          <i className='bi bi-send me-2'></i>Send Quick Message
                                        </span>
                                      </div>
                                    )}

                                    {AuthenticateUser('edit-contact') && handleShowEditContact && (
                                      <div className='menu-item px-3'>
                                        <span
                                          className='menu-link px-3'
                                          onClick={(e) => handleShowEditContact(val)}
                                        >
                                          <i className='bi bi-pencil me-2'></i>Edit
                                        </span>
                                      </div>
                                    )}

                                    <div className='menu-item px-3'>
                                      <span
                                        className='menu-link px-3'
                                        onClick={() => {
                                          navigator.clipboard.writeText(val._id)
                                          toast.success('Successfully copied contact id')
                                        }}
                                      >
                                        <i className='bi bi-clipboard me-2'></i>Copy ID
                                      </span>
                                    </div>

                                    {AuthenticateUser('edit-contact') && (
                                      <div className='menu-item px-3'>
                                        <span
                                          className='menu-link px-3 text-danger'
                                          onClick={() => handleDeleteSelected(val._id)}
                                        >
                                          <i className='bi bi-trash me-2 text-danger'></i>Delete
                                        </span>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td
                              colSpan={
                                9 +
                                groupField.length +
                                (groupField.length > 3 ? groupField.length - 3 : 0)
                              }
                              className='text-center'
                            >
                              <b>Data not found</b>
                            </td>
                          </tr>
                        )}
                      </>
                    )}
                  </tbody>
                </table>
              </div>
            )}
            <PrevNexPaginate
              isFetching={isCountLoading || isFetchLoading || isFetchCountLoading || isLoading}
              limit={params.limit ? params.limit : 10}
              handleChangSizeData={handleChangSizeData}
              next={next}
              prev={prev}
              loadedData={loadedData}
              totalData={totalData}
              handleChange={handleChangePage}
            />
          </div>
        </div>
      )}
    </div>
  )
}

ContactListPanel.defaultProps = {
  showFilterStatus: true,
  showFilterTag: true,
  showSendMessageAction: true,
  showSubscribeStatus: true,
  showExport: true,
  showTag: true,
  showAddTag: true,
  tags: [],
  isDeleteLoading: false,
  showFilterField: true,
  handleSetSort: (key: string, value: string) => {},
}

export default memo(ContactListPanel)
